import React, { Component } from 'react';
import Dashboard from '../components/adminPanel/DashBoard/Dashboard';
import AdminNavBar from '../components/adminPanel/AdminNavBar/AdminNavBar';

class AdminPanel extends Component {
    render() {
        return (
            <div className="container">


                <Dashboard />
                <br/><br/>
                <AdminNavBar />
            </div>
        );
    }
}

export default AdminPanel;
